<template>
  <div class="process-easy-connection">
    <el-form class="form" :inline="true">
          <div class="connection">
            <div class="title">{{connection.defaultLine ?'默认流转':"流转"+ connectionIndex}}</div>
            <div class="process-content">
              <div class="target">
                <el-form-item label="操作按钮">
                  <el-select disabled v-model="connection.actionId">
                    <el-option v-if="action.type !== '打印'" :label="action.name" :value="action.id" v-for="action in getCurrentNode.actions" :key="action.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="目标节点" >
                  <el-select disabled v-model="connection.targetNodeId">
                   <el-option :label="node.name" :value="node.id" v-for="node in targetNode" :key="node.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作类型" v-if="getTargetNodeTypeById(connection.targetNodeId)==='cancelEvent'">
                  <el-select disabled v-model="connection.operationType">
                    <el-option label="终止" value="cancelEvent"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作类型" v-else-if="getTargetNodeTypeById(connection.targetNodeId)==='endEvent'">
                  <el-select disabled v-model="connection.operationType">
                    <el-option label="结束" value="endEvent"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作类型" v-else>
                  <el-select disabled v-model="connection.operationType">
                    <el-option label="正常" value="normal"></el-option>
                    <el-option label="返回" value="back"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="warning">
                <el-form-item label="流转提醒">
                 <span class="ways setting"  @click="openInformDialog"><i class="el-icon-setting"></i>设置</span>
                </el-form-item>
              </div>
            </div>
          </div>
      </el-form>

  </div>
</template>
<script>

export default {
  name: 'process-easy-connection',
  props: ['nodes', 'connection', 'connectionIndex', 'currentNodeId'],
  data () {
    return {
      inform: {
        connectionId: '',
        dialogVisible: false
      }
    }
  },
  methods: {
    getTargetNodeTypeById (targetId) {
      let targetNode = this.targetNode.find(m => m.id === targetId)
      if (targetNode) {
        return targetNode.type
      }
    },
    openInformDialog () {
      this.inform.connectionId = this.connection.id
      this.inform.connection = this.connection
      this.inform.sourceNodeId = this.connection.sourceNodeId
      this.inform.notice = this.connection.notice
      this.inform.dialogVisible = true
      this.$emit('openDialogInform', this.inform)
    }
  },
  computed: {
    getCurrentNode () {
      return this.nodes.find(m => m.id === this.currentNodeId)
    },
    targetNode () {
      return this.nodes.filter(m => m.id !== this.currentNodeId)
    },
    currentNode () {
      return this.nodes.filter(m => m.id === this.currentNodeId)[0]
    }

  },
  watch: {
    'connection.notice.enable' (val) {
      if (!val) {
        this.connection.notice.processTitle = ''
        this.connection.notice.template = ''
        this.connection.notice.targetNode = []
        this.connection.notice.targetUser = []
        this.connection.notice.targetComponent = []
      } else {
        this.connection.notice.template = '流程内容:${' + 'processName' + '};发起人员:${' + 'startName' + '}; 发起时间:${' + 'startTime' + '}'
        this.connection.notice.targetNode = [this.connection.targetNodeId]
        this.connection.notice.processTitle = ''
      }
    },
    'connection.targetNodeId' (newValue, oldVlaue) {
      if (newValue) {
        // 第一次目标节点没有值,下一个节点通知人没有值,所以加上为0的情况
        if (this.connection.notice.targetNode.length === 0 || (this.connection.notice.targetNode.length === 1 && this.connection.notice.targetNode[0] === oldVlaue)) {
          this.connection.notice.targetNode = [newValue]
        }
      }
    }
  }
}
</script>

<style lang="scss">
.process-easy-connection {
  .form {
    .connection {
      background: #fff;

      &:hover {
        background: #F4F9FD;
      }

      .title {
        background: #EBF5FF;
        height: 27px;
        line-height: 27px;
        padding-left: 9px;
        position: relative;

        .close {
          position: absolute;
          top: 7px;
          right: 10px;
          color: #6BB7F3;
        }
      }

      .process-content {
        padding: 16px 8px 5px;

        .el-form-item__label
          {
          font-size: 12px;
          padding: 0 8px 0 0;
        }

        span {
          font-size: 12px;
        }

        .target {
          .el-form-item__content {
            width: 98px;
          }

          .el-form-item {
            &:nth-child(3) {
              margin-right: 0;
            }
          }
        }

        .conditions {
          .condition-header {
            margin-bottom: 2px;

            .el-form-item__content {
              color: #B4B5B5;
              font-size: 12px;
            }
          }

          .change-condition {
            padding: 3px 8px;
          }

          .add {
            margin-left: 248px;
          }

          .table-connection {
            margin-bottom: 16px;
            td {
              width: 105px;
            }
          }

          .table-connection,
          tr,
          td {
            background: transparent;

            .el-input__inner {
              border: none;
              background: transparent;
            }

            .first .el-input__inner {
              padding-left: 0;
            }

            td {
              border-bottom: 1px solid #E3E4E5;

              &:last-child {
                text-align: right;
                color: #6BB7F3;
                border: none;
                width: 64px;
                visibility: hidden;
                cursor: pointer;
                &:active {
                   color: #388DD2;
                }
              }
            }

            tr:hover {
              td {
                border-bottom: 1px solid #54ABF1;

                &:last-child {
                  visibility: visible;
                }
              }
            }
          }

          ::-webkit-input-placeholder {
            color: #606266;
          }

          ::-moz-placeholder {
            color: #606266;
          }

          :-ms-input-placeholder {
            color: #606266;
          }
        }

        .warning {
          position: relative;

          .el-form-item__content {
            position: inherit;
          }
          .notice-switch {
            position: absolute;
            right: 66px;
            top: 4px;
          }
          .el-form-item span.ways {
            color: #606266;

            &:nth-child(1) {
              margin-right: 30px;
            }

            &:nth-child(2) {
              position: relative;
            }

            &.setting {
              color:var(--light-1, #6BB7F3);
              position: absolute;
              top: 0;
              right: 10px;
              cursor: pointer;

              i {
                margin-right: 8px;
              }
            }
          }
        }

        .time {
          position: relative;

          .el-form-item__content {
            width: 118px;
          }

          .el-form-item.specific-time {
            .el-form-item__content {
              width: 284px;
            }

            .el-input {
              width: 80px;
              margin-right: 10px;
              .el-input__inner{
                padding-right: 5px;
              }

              .el-input-group__append {
                padding: 0 4px;
              }
            }
          }

          .tooltip {
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
            color: #c9c0c0;

            &:hover {
              color: #409EFF;
            }
          }
        }

      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-easy-connection.vue